import {
  BookOrderFoodModel,
  BookOrderFoodQueryModel,
  BookOrderFoodSumModel,
} from '@/model/bookOrderFood';
import { ResultModel } from '@/model/viewModel';
import { post } from '@/utils/api';

export const getBookOrderFood = (data: BookOrderFoodQueryModel) =>
  post<ResultModel<BookOrderFoodModel>>('/report/selectBookOrderFood', data);

export const getBookOrderFoodSum = (data: BookOrderFoodQueryModel) =>
  post<BookOrderFoodSumModel>('/report/selectBookOrderFoodSum', data);
